import VueApollo from 'vue-apollo';
import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
// import * as RealmWeb from 'realm-web'; // DEPRECATED - auth via Nexus now
import axios from 'axios';
import { clearAuth, getAccessToken } from '@/services/secureStorage';
import { stopTokenRefreshTimer } from '@/utils/tokenRefreshTimer';
import { clearEnhancedAuthState } from '@/utils/auth-state-persistence';
import { useRealmAppState } from './store';

const { app } = useRealmAppState(['app']);
// Install the vue plugin
// Name of the localStorage item
const AUTH_TOKEN = 'apollo-token';

//  Mongo App Setup

// Creates needed headers
const httpEndpoint = import.meta.env.VITE_GRAPHQL_HTTP;
const httpLink = createHttpLink({ uri: httpEndpoint });

const authorizationHeaderLink = () =>
  setContext(async (_, { headers }) => {
    // Auth via Nexus JWT (Realm deprecated)
    const accessToken = getAccessToken();

    return {
      headers: {
        ...headers,
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
      }
    };
  });

// Create the Apollo client with modern @apollo/client
export const apolloClient: any = new ApolloClient({
  link: from([authorizationHeaderLink(), httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      // CRITICAL: ProgramCredentials uses 'id' as ordinal index (1, 2, 3...) per program,
      // NOT as a unique identifier. Without this, Apollo incorrectly caches all credentials
      // as the same object because they all have id: 1, causing all programs to show
      // the same credential from the first cached program.
      ProgramCredentials: {
        keyFields: false // Treat as embedded object, don't normalize by id
      }
    }
  }),
  devtools: { enabled: process.env.NODE_ENV === 'development' }
});

export async function onLogin(token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token);
    const response = await axios.get(`${import.meta.env.VITE_AUTH0}/permissions`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('apollo-token')}`
      }
    });
    if (response?.data?.data) {
      localStorage.setItem('permissions', response?.data?.data?.permissions);
      localStorage.setItem('statistics', JSON.stringify(response?.data?.data?.statistics));
    }
  }
  // try {
  //   await apolloClient.resetStore();
  // } catch (e) {
  //   // eslint-disable-next-line no-console
  //   console.log('%cError on cache reset (login)', 'color: orange;', e.message);
  // }
}

// Manually call this when user log out
export async function onLogout() {
  // Stop the proactive token refresh timer so it doesn't keep firing
  stopTokenRefreshTimer();

  // Remove all auth artefacts via secureStorage abstraction (handles
  // both localStorage and cookie modes transparently)
  clearAuth();

  // Clear intermediate auth flow state so stale recovery data
  // doesn't trigger a bootloop on next visit.
  clearEnhancedAuthState();

  // Legacy clean-up: some older screens still check these keys directly.
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem('apollo-refresh-token');
    localStorage.removeItem('profileComplete');
  }

  // Remove any default auth header we may have set on axios so that
  // subsequent unauthenticated requests don't carry a stale token.
  delete axios.defaults.headers.common.Authorization;

  // Optionally reset Apollo cache (commented out to avoid expensive refetches; uncomment if needed)
  // try {
  //   await apolloClient.resetStore();
  // } catch (e) {
  //   console.warn('Error on cache reset (logout)', e.message);
  // }
}
const provider = new VueApollo({
  defaultClient: apolloClient
});
export default provider;
// watchEffect(() => {
//   if (app.value.currentUser) {
//     onLogin(app.value.currentUser.accessToken);
//   } else {
//     onLogout();
//   }
// });
